import OperatorIncidents from "../../../app/operator/incidents";
import OperatorIncidentForm from "../../../app/operator/incidents/components/Form";
import OperatorProtocols from "../../../app/operator/protocols";
import OperatorStatistics from "../../../app/operator/statistics";
import OperatorUsers from "../../../app/operator/users";
import Settings from "../../../app/settings";

export const operatorRoutes = [
  {
    category: "Incidents",
    path: "/incidents",
    icon: "ph-duotone ph-warning",
    title: "navigation.incidents",
    component: <OperatorIncidents />,
    showInSidebar: true,
  },
  {
    path: "/incidents/create",
    component: <OperatorIncidentForm />,
  },
  {
    path: "/incidents/:incidentId",
    component: <OperatorIncidentForm />,
  },
  {
    category: "Protocols",
    path: "/protocols",
    icon: "ph-duotone ph-clipboard-text",
    title: "navigation.protocols",
    component: <OperatorProtocols />,
    showInSidebar: true,
  },
  {
    path: "/protocols/create",
    component: <OperatorProtocols />,
  },
  {
    path: "/protocols/:protocolId",
    component: <OperatorProtocols />,
  },
  {
    category: "Statistics",
    path: "/statistics",
    icon: "ph-duotone ph-chart-line-up",
    title: "navigation.statistics",
    component: <OperatorStatistics />,
    showInSidebar: true,
  },
  {
    category: "Users",
    path: "/users",
    icon: "ph-duotone ph-users",
    title: "navigation.users",
    component: <OperatorUsers />,
    showInSidebar: true,
  },
  {
    path: "/users/:userId",
    component: <OperatorUsers />,
  },
  {
    path: "/users/create",
    component: <OperatorUsers />,
  },
];

